import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.spacing(3),
    margin: theme.spacing(0, 1),
    transition: theme.transitions.create(),

    '&:not(.open)': {
      '& .input': {
        '&-container': {
          width: 0,
          overflow: 'hidden',
        },
      },
      '& .btn-close': {
        display: 'none',
      },
    },

    '&.open': {
      backgroundColor: theme.palette.custom.surface[2],
    },

    '& .input': {
      '&-container': {
        width: 150,
        maxWidth: '100%',
        flexGrow: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: theme.transitions.create(),
      },

      '&': {
        width: '100%',
        backgroundColor: 'transparent',
        border: 'none',
        flexGrow: 1,
        outline: 'none',
        ...theme.typography.body2,
        color: theme.palette.text.secondary,
      },
    },

    '& .btn-close': {
      color: theme.palette.text.disabled,
    },
  },
  btnIconContainer: {
    margin: theme.spacing(0),
  },
}));

export default styles;
